// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1pW_b","col":"styles_col__3ewPX"};